import { Component, Input } from '@angular/core';
import { SignDetail } from '../../../model/sign/sign-detail';
import { SignStickerDetail } from '../../../model/sign/sticker/sign-sticker-detail';

type InfoType = 'immo' | 'installer' | 'graphical' | 'atelier';

@Component({
  selector: 'sign-info',
  templateUrl: './sign-info.component.html',
  styleUrls: ['./sign-info.component.scss'],
})
export class SignInfoComponent {
  @Input() signDetail?: SignDetail;
  @Input() otherSideSignDetail?: SignDetail;

  @Input() signStickerDetail?: SignStickerDetail;
  @Input() otherSideSignStickerDetail?: SignStickerDetail;

  @Input() type: InfoType;

  constructor() {}

  get capitalizedType(): string {
    switch (this.type) {
      case 'immo':
        return 'Immo';
      case 'graphical':
        return 'Grafische';
      case 'installer':
        return 'Installateur';
      case 'atelier':
        return 'Atelier';
    }
  }

  get shouldShowInfo(): boolean {
    return (
      this.hasSignInfo(this.signDetail) ||
      this.hasSignInfo(this.otherSideSignDetail) ||
      this.hasStickerInfo(this.signStickerDetail) ||
      this.hasStickerInfo(this.otherSideSignStickerDetail)
    );
  }

  hasSignInfo(sign?: SignDetail): boolean {
    if (!sign) return false;
    const signType = this.type === 'atelier' ? 'studio' : this.type;
    const value = sign[`${signType}Value`];
    const info = sign[`${signType}Info`];
    return !!value && !!info && info.length > 0;
  }

  hasStickerInfo(sticker?: SignStickerDetail): boolean {
    if (!sticker) return false;
    const value = sticker[this.type];
    const info = sticker[`${this.type}Info`];
    return !!value && !!info && info.length > 0;
  }

  getSignInfo(sign?: SignDetail): string | undefined {
    const signType = this.type === 'atelier' ? 'studio' : this.type;
    return sign?.[`${signType}Info`];
  }

  getStickerInfo(sticker?: SignStickerDetail): string | undefined {
    return sticker?.[`${this.type}Info`];
  }
}
